import KidoAPIInstance from "../../services/KidoConfigApi";

export const getCRMLevelInfoApi = async () => {
	const path = "api/getCRMLevelInfo";
	return await KidoAPIInstance.get(path);
};
